// extracted by mini-css-extract-plugin
export default {"container":"AddApp_container__oXQjy","input_container":"AddApp_input_container__VHZWv","btnBox":"AddApp_btnBox__74Zcu"};